// extracted by mini-css-extract-plugin
module.exports = {"JumpNav":"JumpNav_JumpNav__q48_h","Item":"JumpNav_Item__csnO3","ItemActive":"JumpNav_ItemActive__G2nR4"};